module.exports = __webpack_public_path__ + "static/hungr-1c6b40d5a430f8500557bc1fc0c40e42.gif";